export { default } from './AccountDetail';
